export default "__VITE_ASSET__D57DjF8x__"